var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
export default function submitAIAdLandingForm(formData) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        try {
            const response = yield api.post('/ai-ad-landing', {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                form_data: formData
            });
            if (response.data && response.data.success) {
                return {
                    success: true,
                    message: response.data.message || 'Form submitted successfully!'
                };
            }
            const errorData = response.data;
            throw new Error(errorData.message || 'Form submission failed');
        }
        catch (error) {
            console.error('Form submission error:', error);
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                if (axiosError.code === 'NETWORK_ERROR' || !axiosError.response) {
                    throw new Error('Network error. Please check your connection and try again.');
                }
                if ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
                    throw new Error(axiosError.response.data.message);
                }
                if (((_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.status) === 422) {
                    throw new Error('Please check your input and try again.');
                }
            }
            const errorMessage = error instanceof Error ? error.message : 'An unexpected error occurred. Please try again.';
            throw new Error(errorMessage);
        }
    });
}
